import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GeocoderReq} from './models/geocoder-req';
import { Observable, of, Subject } from 'rxjs';
import {Geocoder} from './models/geocoder';
import {config} from '../../shared/config';
import { map } from 'rxjs/operators';
import { DataHelper } from '../../shared/helpers/data.helper';
import { BaseHttpService } from '../services/base-http.service';
import { StorageService } from '../storage/storage.service';
import { GeocoderAddressReq } from './models/geocoder-address-req';
import { GeocoderAddress } from './models/geocoder-address';

@Injectable({
  providedIn: 'root'
})
export class GeocoderService extends BaseHttpService {
  private geocoderDataSubject: Subject<GeocoderAddress[]> = new Subject<GeocoderAddress[]>();
  public geocoderData: Observable<GeocoderAddress[]> = this.geocoderDataSubject.asObservable();

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getGeocoder(request: GeocoderReq[]): Observable<Geocoder[]> {
    const fields = ['id', 'address', 'village', 'town', 'houseNumber', 'road', 'neighbourhood', 'cityDistrict', 'city', 'county', 'state', 'postcode', 'country', 'countryCode', 'latitude', 'longitude'];

    return this._http.post(config.generateApiUrl('geocoder/reverse', fields), request, {headers: { ignoreLoadingBar: '' }}).pipe(
      map(response => response['data']['items'])
    );
  }

  getGeocoderByAddress(request: GeocoderAddressReq) {
    this.geocoderDataSubject.next([]);

    const queryParams = [
      `query=${encodeURIComponent(request.street || '')}`,
      encodeURIComponent(request.city || ''),
      encodeURIComponent(request.county || ''),
      encodeURIComponent(request.state || ''),
    ];

    const queryString = `?${queryParams.filter(Boolean).join('+')}&limit=10`;

    return this._http.get(config.generateApiUrl('geocoder/search' + queryString, ['*'])).pipe(
        map(response => {
          const data = response['data']['items'];
          this.geocoderDataSubject.next(data);
        }),
    );
  }

  autocomplete(text: string): Observable<any[]> {
    if (DataHelper.isNotEmpty(text)) {
      return this.get(config.generateApiUrl(`geocoder/autocomplete/${text}`, ['*']), {headers: {ignoreLoadingBar: ''}}).pipe(
        map(response => response['data']['suggestions'])
      );
    } else {
      return of([])
    }
  }
}
